// import dispatchAlert from '../Alert/dispatchAlert';
import db from '../../config/databases/forms';
import getUserId from '../Auth/getUserId';

export default async function getFormsObj(all = false) {
  const userId = getUserId();
  const forms = {};
  try {
    await db.forms.each((form, cursor) => {
      if (form.buyerId === userId || all) forms[cursor.key] = form;
    });
  } catch (e) {
    // dispatchAlert('idb_error', 'danger', 'idb_error');
    throw new Error('IDB_UNKNOWN_ERROR');
  }
  return forms;
}
